const NAME = "DELEGATE_ATTENTIONS_PAGE";

export default NAME;
